import { strings } from '@/shared/strings';
import styles from './AccessGaps.module.css';

export interface AccessGap {
  /** Whose it is, where the list is of more than one: a role's name. */
  who?: string;
  sentence: string;
}

/**
 * What was given and will not work as it stands: a screen ticked without the
 * permission its work rests on, a permission without the one it rests on. The
 * lab's request of 11 October 2026. Shown under the matrix, a line for each
 * role it is true of, and on a person's Special access for that person.
 *
 * Nothing when all of it works, which is how the lab's own matrix starts. The
 * sentences are the domain's, `accessGaps`.
 */
export function AccessGaps({ gaps }: { gaps: readonly AccessGap[] }) {
  if (gaps.length === 0) return null;
  return (
    <section className={styles.gaps} aria-label={strings.access.gapsTitle} data-testid="access-gaps">
      <h4 className={styles.title}>{strings.access.gapsTitle}</h4>
      <p className={styles.lead}>{strings.access.gapsLead}</p>
      <ul className={styles.list}>
        {gaps.map((gap) => (
          <li key={`${gap.who ?? ''}:${gap.sentence}`}>
            {gap.who !== undefined && <b>{gap.who}: </b>}
            {gap.sentence}
          </li>
        ))}
      </ul>
    </section>
  );
}
